// extracted by mini-css-extract-plugin
export default {"ChecksStatusBadgeButton":"ChecksStatusBadge-module__ChecksStatusBadgeButton--rZYKL","ChecksStatusBadgeIconButton":"ChecksStatusBadge-module__ChecksStatusBadgeIconButton--rpD4z"};